var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGrowthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.71667in",
    height: "1.56in",
    viewBox: "0 0 515 468",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Izbor #2",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1,
    d: "M 389.60,52.00            C 389.60,52.00 406.40,80.00 406.40,80.00              406.40,80.00 437.00,131.00 437.00,131.00              437.00,131.00 453.00,159.00 453.00,159.00              453.00,159.00 430.00,159.00 430.00,159.00              430.00,159.00 430.00,362.00 430.00,362.00              430.00,362.00 329.00,362.00 329.00,362.00              329.00,362.00 329.00,159.00 329.00,159.00              329.00,159.00 306.00,159.00 306.00,159.00              306.00,159.00 330.40,117.00 330.40,117.00              330.40,117.00 379.00,36.00 379.00,36.00              379.00,36.00 389.60,52.00 389.60,52.00 Z            M 298.00,229.00            C 298.00,229.00 298.00,362.00 298.00,362.00              298.00,362.00 196.00,362.00 196.00,362.00              196.00,362.00 196.00,229.00 196.00,229.00              196.00,229.00 298.00,229.00 298.00,229.00 Z            M 142.00,300.00            C 142.00,300.00 159.00,300.00 159.00,300.00              160.95,300.04 163.63,299.90 164.98,301.60              166.23,303.19 166.00,307.01 166.00,309.00              166.00,309.00 166.00,355.00 166.00,355.00              165.86,362.49 163.74,361.99 157.00,362.00              157.00,362.00 64.00,362.00 64.00,362.00              64.00,362.00 64.00,300.00 64.00,300.00              64.00,300.00 142.00,300.00 142.00,300.00 Z            M 430.00,392.00            C 430.00,392.00 430.00,423.00 430.00,423.00              430.00,423.00 64.00,423.00 64.00,423.00              64.00,423.00 64.00,392.00 64.00,392.00              64.00,392.00 430.00,392.00 430.00,392.00 Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowthIcon);
export default __webpack_public_path__ + "static/media/growth-icon.9477cc1c.svg";
export { ForwardRef as ReactComponent };